var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note"},[_c('p',[_vm._v(_vm._s(_vm.note.message))]),_c('trash-2-icon',{staticClass:"trash-icon",attrs:{"size":"1x"},on:{"click":function($event){return _vm.remove(_vm.note.id)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }